// Module
var code = "<div> <div class=\"page-toolbar\" :class=\"{'sticky-toolbar': scrolled}\" v-on=\"handleScroll()\"> <slot/> </div> <div :class=\"{'space-toolbar': scrolled}\"/> </div> ";
// Exports
export default code;